/**
 * api接口统一管理
 */
import { get, post, deleteFn, put, deleteBody, axios_ } from './http'
const baseURL = axios_.defaults.baseURL

//OpenId登录
export const loginForOpenId = params => post('/score/scoreUser/login', params)
//手机号登录
export const loginForMobile = params => post('/score/scoreUser/bindMobile', params)
//授权查询移动积分
export const getCmccPower = params => get('/score/scoreUser/cmccPower', params)
//静态过度页面参数查询
export const getPkParamStr = params => get('/score/scoreUser/pkParamStr', params)
//登录日志新增
export const addLoginLog = params => post('/score/scoreVisitLog/save ', params)

//创建订单
export const createOrder = params => post('/score/scoreOrder/add', params)
//支付接口
export const doPay = params => post('/score/scorePayLog/pay', params)
//移动积分转畅游积分
export const doCmccExchange = params => post('/score/scoreCmExchange/cmccExchange', params)

//发送短信--畅由积分转券
export const sendCySms = params => get('/score/scorePaySendLog/paySend', params)
//发送短信--移动积分转畅由积分 
export const sendCmccSms = params => get('/score/scoreSmsLog/sendCmccSms', params)


//产品查询
export const getProduct = params => get('/score/scoreProduct/list', params)
//移动积分上限
export const getUpLimit = params => get('/score/scoreUser/isUpLimit', params)



//添加
export const contactAdd = params => get('/temp/addContact', params)
//新增
export const addShopCar = params => post('/score/scoreUser/login', params)


//配置
export const getThemeConfig = params => get('/score/scoreConfig/getValues', params)